import { emailSchema, phoneRequiredSchema, select2OptionalSchema, select2RequiredSchema, statusSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, object, string } from 'yup';
import errorMessages from 'utils/validation/errorMessages';

const addPeerSchema = object().shape({
    firstname: stringRequiredSchema,
    lastname: stringRequiredSchema,
    dob: stringRequiredSchema,
    address: stringOptionalSchema,
    city_town: stringRequiredSchema,
    phone: phoneRequiredSchema,
    email: emailSchema,
    gender: select2OptionalSchema,
    emergency_contact_last_name: stringRequiredSchema,
    emergency_contact_first_name: stringRequiredSchema,
    emergency_contact_phone: phoneRequiredSchema,
    referring_agency_name: stringRequiredSchema,
    referring_agency_phone: stringRequiredSchema,
    status: statusSchema,
    note: stringOptionalSchema,
    documents: array()
        .of(object().shape({
            attachment_key: stringRequiredSchema,
            attachment_name: stringRequiredSchema
        })),
    referring_agency_name: string()
        .optional()
        .nullable(),
    referring_agency_phone: string()
        .optional()
        .matches(/^\+?\d+$/, errorMessages.phone)
        .min(8, errorMessages.minLength(8))
});

export default addPeerSchema;